import {observer} from "mobx-react-lite";
import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../helpers";
import moment from "moment";
import Select from "react-select";
import { FTPBreadCrumbs } from "../../components-new/BreadCrumbs";
import { DeleteModal } from "../../components/DeleteModal";
import { htmlValidation } from "../../helpers/utils";
import { PRINT_MEDIA_ROUTES } from "./print-media-settings";

const crumbs = [
    {name: 'Media Dashboard', href: '/media', current: false},
    {name: 'Print Media', href: '#', current: true},
];

export const PrintMediaReportsLanding = observer((props: any) => {
    const rootStore = useStore();
    const navigate = useNavigate();
    const {userStore, mediaStore} = rootStore;

    const [query, setQuery] = useState('');
    const [limit, setLimit] = useState(100);
    const [offset, setOffset] = useState(0);
    const [selectedTags, setSelectedTags] = useState([]);

    const [allTags, setAllTags] = useState([]);
    const [reports, setReports] = useState([]);
    const [total, setTotal] = useState(0);

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);


    const fetchReports = async () => {
        setLoading(true);
        const response = await mediaStore.getPrintMediaReports(query, selectedTags.map(x => {
            return x['value'];
        }), limit, offset);
        if (response.status !== 200) {
            setError(true);
            setLoading(false);
            // navigate('/reports');
            return;
        }
        setAllTags(response.data.tags);
        setTotal(response.data.total);
        setReports(response.data.reports);
        setLoading(false);
    };

    useEffect(() => {
        fetchReports();
    }, [query, selectedTags, offset, limit]);


    const editReport = (event, report: any) => {
        htmlValidation(event)
        navigate(PRINT_MEDIA_ROUTES.reportEdit(report.id));
    }

    const cloneReport = async (event, report: any) => {
        setLoading(true);
        htmlValidation(event)
        const response = await mediaStore.clonePrintMediaReport(report.id);
        if (response.status !== 200) {
            setError(true);
            setLoading(false);
            return;
        }
        fetchReports();
    }

    const [deleteReportModal, setDeleteReportModal] = useState(false)
    const [activeReportId, setActiveReportId] = useState(null)

    const cancelCB = (event) => {
        setDeleteReportModal(false)
    }

    const deleteReport = async (e, id: any) => {
        setLoading(true);
        const response = await mediaStore.deletePrintMediaReport(id);
        if (response.status !== 200) {
            setError(true);
            setLoading(false);
            return;
        }
        fetchReports();
        setDeleteReportModal(false)
    }

    const viewReport = (event, report: any) => {
        navigate(PRINT_MEDIA_ROUTES.reportView(report.id));
    }

    const render_report = (report) => {
        const {created, description, id, name, tags, edit} = report
        return (
            <>
                <div key={`report_${id}`}
                     className="flex flex-col rounded-lg shadow-lg overflow-hidden "
                     style={{borderLeft: '4px solid #4338CA', borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                >
                    <div className="flex-1 bg-white p-3 flex flex-col justify-between cursor-pointer"
                         onClick={(evt) => viewReport(evt, report)}>
                        <div className="flex-1">
                            <p className="text-xl font-semibold text-gray-900">{name}</p>
                            <span className='text-gray-500 text-sm'>{moment(created).format("DD MMM hh:mm")}</span>
                            <p className="mt-2 text-base text-gray-500">{description}</p>
                            <div className={'flex flex-row flex-wrap'}>
                                {
                                    tags.map(x => {
                                        return (
                                            <div
                                                className='mt-2 mr-2 px-2 py-1 bg-blue-100 text-xs rounded-lg'>{x}</div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    {edit ? (
                        <div className='flex flex-row flex-wrap space-x-4 bg-white p-3'>
                            <a className='text-blue-500 cursor-pointer'
                               onClick={(evt) => editReport(evt, report)}>Edit</a>
                            <a className='text-blue-500 cursor-pointer'
                               onClick={(evt) => cloneReport(evt, report)}>Clone</a>
                            {
                                userStore.isRoot() ? (
                                    <a className='text-blue-500 cursor-pointer'
                                       onClick={(evt) => {
                                           setDeleteReportModal(true)
                                           setActiveReportId(report['id'])
                                       }}>Delete</a>
                                ) : null
                            }
                            <DeleteModal onDeleteClick={deleteReport} onCancelClick={cancelCB}
                                         isOpen={deleteReportModal} id={activeReportId}
                                         desc='Do you want to Delete this Report ?'/>
                        </div>
                    ) : null}
                </div>
            </>
        );
    }

    const Loading = (innerprops) => {
        return (
            <div className="ml-4 text-gray-500">
                <i className="fa-2x fa-solid fa-spinner fa-pulse"/>
            </div>
        )
    }

    const addEmptyReportAndNav = async () => {
        setLoading(true);
        const response = await mediaStore.createNewPrintMediaReport();
        if (response.status !== 200) {
            setError(true);
            setLoading(false);
            return;
        }
        setLoading(false);
        navigate(PRINT_MEDIA_ROUTES.reportEdit(response.data.id));
    };

    const AddReport = (innerprops) => {
        return (
            <div className="ml-auto">
                <button className='px-2 py-2 rounded-md bg-indigo-700 text-white' onClick={addEmptyReportAndNav}>Create
                    new Report
                </button>
            </div>
        )
    };

    const Error = (innerprops) => {
        return (
            <div className="text-red-600 italic">
                Error occured while completing operation. Please try again or contact support team.
            </div>
        )
    };

    const ReportsView = (innerprops) => {
        return (
            <>
                <div className='italic'>Showing {reports.length + offset} of {total} reports.</div>
                <div className="mt-5 max-w-none mx-auto grid gap-3 xl:grid-cols-4 lg:grid-cols-3  md:grid-cols-2 ">
                    {
                        reports.map(x => {
                            return render_report(x);
                        })
                    }

                </div>
            </>
        )
    };

    const FilterPane = () => {
        return (
            <div className='py-4 flex flex-row flex-wrap space-y-2 lg:space-y-0'>
                <div className="flex flex-row w-full lg:w-1/2">
                    <input type="search" value={query} onChange={(evt) => {
                        setQuery(evt.target.value);
                    }} className="w-full h-10 pr-8 pl-5 rounded z-0 focus:shadow focus:outline-none"
                           placeholder="Search reports..."/>
                    <div className="relative" style={{top: 10, right: 30}}>
                        <i className="fa fa-search text-gray-400 z-20 hover:text-gray-500"/>
                    </div>
                </div>
                <div className=' w-full lg:w-1/2'>
                    <Select
                        defaultValue={selectedTags}
                        isMulti
                        name="colors"
                        options={allTags.map(x => {
                            return {"value": x, "label": x};
                        })}
                        onChange={(val) => {
                            setSelectedTags(val ? [...val] : []);
                        }}
                        placeholder="Filter by tags..."
                        className="w-full h-10 rounded z-0 focus:shadow outline-none basic-multi-select"
                        classNamePrefix="select"
                    />
                </div>
            </div>
        )
    };


    // @ts-ignore
    return (
        <>
            <FTPBreadCrumbs crumbs={crumbs}/>
            <div className='p-4'>
                <div className='flex flex-row flex-nowrap items-center'>
                    <div className='font-bold text-3xl text-gray-800'>Print Media Reports</div>
                    {loading ? (<Loading/>) : null}
                    {userStore.isRoot() ? (<AddReport/>) : null}
                </div>

                {FilterPane()}
                {(error) ? (<Error/>) : (<ReportsView/>)}

            </div>
        </>
    );
})